import React from 'react';
import CountUp from '../../components/Reactbits/Count';

const WhyChoseAs    = () => {


    const whyChooseAs = [
        {
            count: "200+",
            title: 'Cities Covered',
           image:   "https://s3-alpha-sig.figma.com/img/23ea/8f40/566f1b0f4702dee545026dfeea3203a9?Expires=1744588800&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=BsMEArPueW~GIo9IivPEuFlT0HsTifFseJz2MvuN2TE2c9onDZP-8oz2LfxhlXdxnVX5KQ4zTnMLOHdfI4igVKFb-xL5YYEBJspKjh~wHnvVeT9Ho9aZdfC4eyYFKtQSpPR4NMTjh4pVDycO0lFOzUX2Nndnhz9rf12BlNjKT~Qq7TyRxJYsFSNbtfY46aBry6MMxOmoUSdNf9GweXfSbelHlIz~Tx0UyeYRLuUBfm64w0p8QRUTZgWswacAPogWUtQdAKb~lQD~TBKBBYwibNQ40Pe5B4q9-uYQjzBvVNd4P6h5liDu8Dng9JWNnvdkdDAKQKIkUrtfvffmQpWf1A__"
        },
        {
            count: "30000",
            title: 'Reliable',
            image: "https://s3-alpha-sig.figma.com/img/23ea/8f40/566f1b0f4702dee545026dfeea3203a9?Expires=1744588800&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=BsMEArPueW~GIo9IivPEuFlT0HsTifFseJz2MvuN2TE2c9onDZP-8oz2LfxhlXdxnVX5KQ4zTnMLOHdfI4igVKFb-xL5YYEBJspKjh~wHnvVeT9Ho9aZdfC4eyYFKtQSpPR4NMTjh4pVDycO0lFOzUX2Nndnhz9rf12BlNjKT~Qq7TyRxJYsFSNbtfY46aBry6MMxOmoUSdNf9GweXfSbelHlIz~Tx0UyeYRLuUBfm64w0p8QRUTZgWswacAPogWUtQdAKb~lQD~TBKBBYwibNQ40Pe5B4q9-uYQjzBvVNd4P6h5liDu8Dng9JWNnvdkdDAKQKIkUrtfvffmQpWf1A__"
        },
        {
            count: "10000",
            title: 'Cost-Effective',
            image: "https://s3-alpha-sig.figma.com/img/23ea/8f40/566f1b0f4702dee545026dfeea3203a9?Expires=1744588800&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=BsMEArPueW~GIo9IivPEuFlT0HsTifFseJz2MvuN2TE2c9onDZP-8oz2LfxhlXdxnVX5KQ4zTnMLOHdfI4igVKFb-xL5YYEBJspKjh~wHnvVeT9Ho9aZdfC4eyYFKtQSpPR4NMTjh4pVDycO0lFOzUX2Nndnhz9rf12BlNjKT~Qq7TyRxJYsFSNbtfY46aBry6MMxOmoUSdNf9GweXfSbelHlIz~Tx0UyeYRLuUBfm64w0p8QRUTZgWswacAPogWUtQdAKb~lQD~TBKBBYwibNQ40Pe5B4q9-uYQjzBvVNd4P6h5liDu8Dng9JWNnvdkdDAKQKIkUrtfvffmQpWf1A__"
        }
    ]




    return (
        <div  style={{margin: '60px  50px',borderRadius: '20px',paddingLeft: '50px',paddingTop: '60px'}} className=''>
            <div className='row'>
                <div className='col-md-5'>
                <h2 style={{fontWeight: '700', color: '#006FB4',fontFamily: 'Montserrat',fontSize: '42px'}} >Why
                        <br></br>
                    Choose Us</h2>
                    <p style={{fontWeight: '500', color: 'black',fontFamily: 'Montserrat',fontSize: '18px',paddingRight: '200px' }} >
                    Fast, reliable, and cost-effective logistics solutions. On-time delivery with seamless tracking. Your trusted partner in supply chain efficiency.
                    </p>

                </div>
                <div  className='col-md-7'>
                    {whyChooseAs.map((item, index) => (
                        <div key={index} className='d-flex justify-content-between mb-4' >
                            <div className=''>
                                <h3 style={{fontWeight: '800', color: '#006FB4',fontFamily: 'Montserrat',fontSize: '92px'}} >
                                    <CountUp to={item.count} duration={2} />
                                </h3>
                                <p style={{fontWeight: '500', color: 'black',fontFamily: 'Montserrat',fontSize: '30px'}} >{item.title}</p>
                            </div>
                            <div className=''>
                                <img  style={{width: '273px', height: '145px', borderRadius: '20px',objectFit: 'cover'   }} className='img-responsive' src={item.image} alt={item.title} />
                            </div>
                            
                        </div>
                    ))}

                </div>
            </div>



        </div>
    );
}

export default WhyChoseAs
;


